import { styled } from '@mui/system';
import { Box, Card, Typography } from '@mui/material';
import { fontFamilies } from '../../../../../constants/theme';
import {
  SectionHeading as BaseSectionHeading,
} from '../../../../../ui/typography';

export const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: '40px 40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: '30px 20px',
  },
}));

export const ContentWrapper = styled(Box)({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
});

export const SectionHeading = styled(BaseSectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
  marginBottom: 16,
}));

export const SectionSubtext = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
  marginBottom: 24,
}));

export const BioCard = styled(Card)({
  backgroundColor: '#fff',
  borderRadius: 16,
  padding: 32,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  width: '100%',
});

export const BioText = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: 18,
  lineHeight: 1.8,
  color: '#666',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: { fontSize: 16 },
}));
